import React from 'react';
import { getResourcesLinks } from '@fiverr-private/resources_tab';
import { Dropdown, DropdownAnchor, DropdownContent, DropdownMenu, MenuItem } from '@fiverr-private/dropdown';
import { Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { NewBadge } from '@fiverr-private/badges';
import { I18n } from '@fiverr-private/i18n-react';
import { TriggerButton } from '../../blocks';

type ResourceLink = ReturnType<typeof getResourcesLinks>[number];

const ExploreListItem = ({ link }: { link: ResourceLink }) => {
    const { href, copyKeys, isNew, anchorAttributes, reportBQ } = link;

    return (
        <MenuItem href={href} onClick={() => reportBQ()} target={anchorAttributes.target} rel={anchorAttributes.rel}>
            <Stack direction="column" gap="0">
                <Stack gap="1.5" alignItems="center">
                    <Text fontWeight="semibold" color="bodyPrimary">
                        <I18n k={copyKeys.name} />
                    </Text>
                    {isNew && <NewBadge />}
                </Stack>
                <Text color="bodySecondary" size="b_sm">
                    <I18n k={copyKeys.caption} />
                </Text>
            </Stack>
        </MenuItem>
    );
};

export const ExploreNavigation = () => {
    const links = getResourcesLinks({ headerType: 'logged_out' });

    return (
        <Dropdown>
            <DropdownAnchor>
                <TriggerButton>
                    <I18n k="resources_tab.title" />
                </TriggerButton>
            </DropdownAnchor>
            <DropdownContent width="350px">
                <DropdownMenu maxHeight="auto">
                    {links.map((link) => (
                        <ExploreListItem key={link.key} link={link} />
                    ))}
                </DropdownMenu>
            </DropdownContent>
        </Dropdown>
    );
};
